/**
 * Input-Mode-Adaptive Hint Text
 *
 * Centralizes HUD/menu hint strings and swaps them based on
 * Input.inputMode (keyboard/gamepad/touch). Renderers call these
 * functions each frame — PixiJS Text guards against same-string no-ops.
 */

import { Input } from 'bonkjs';

// ─── Menu Labels ─────────────────────────────────────────────

const MENU_LABELS = {
  keyboard: {
    confirm: 'SPACE / ENTER',
    back: 'ESC',
    navigate: '\u2191\u2193',  // ↑↓
  },
  gamepad: {
    confirm: '[A]',
    back: '[B]',
    navigate: 'D-PAD \u2191\u2193',
  },
  touch: {
    confirm: 'TAP',
  },
} as const;

// ─── Composed Hint Strings ───────────────────────────────────

/** Start prompt text (title screen). */
export function getStartPrompt(): string {
  const mode = Input.inputMode;
  if (mode === 'touch') return 'TAP TO START';
  if (mode === 'gamepad') return 'PRESS [A] TO START';
  return 'PRESS SPACE / ENTER TO START';
}

/** Back button label (mode-adaptive). */
export function getBackButtonLabel(): string {
  const mode = Input.inputMode;
  if (mode === 'touch') return 'BACK';
  if (mode === 'gamepad') return 'BACK ([B])';
  return 'BACK (ESC)';
}

/** DI window prompt (touch: left stick, otherwise: hold direction). */
export function getDIHint(): string {
    if (Input.inputMode === 'touch') return 'USE LEFT STICK';
    return 'HOLD DIRECTION';
}

/** Burst window prompt (touch: left stick, otherwise: hold direction). */
export function getBurstHint(): string {
    if (Input.inputMode === 'touch') return 'USE LEFT STICK';
    return 'HOLD DIRECTION';
}
